module.exports = __webpack_public_path__ + "fonts/Gotham-Book.9565527b.woff";